<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import AdditionalHelp from "./../Components/AdditionalHelp.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import { inertia } from "@inertiajs/svelte";
  import AddressFaq from "../FAQ/AddressFaq.svelte";
  export let address;
</script>

<PageHead>
  <svelte:fragment slot="title">Address Change Complete</svelte:fragment>
  <svelte:fragment slot="tagline"
    >Your address change has been submitted.</svelte:fragment
  >
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="address"></span>
    <span slot="complete"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-md-8">
    <div class="card">
      <div class="card-header d-flex justify-content-between fw-bold">
        <div>Vehicle</div>
        <div>
          {address.VehicleDetail.Year}
          {address.VehicleDetail.Make}
          {address.VehicleDetail.Model}
        </div>
      </div>
      <div class="card-body">
        <Alerts />

        <div class="row">
          <div class="col-md-6">
            <span class="fw-light">Owner Address</span>
            <hr />
            {address.OwnerAddress.Address1}
            {address.OwnerAddress.Address2 || ""}<br />
            {address.OwnerAddress.City}, {address.OwnerAddress.State}
            {address.OwnerAddress.ZipCode}<br />
            {address.OwnerAddress.County || ""}
          </div>
          <div class="col-md-6 mt-4 mt-md-0">
            <span class="fw-light">Renewal Address</span>
            <hr />
            {address.RenewalAddress.Address1}
            {address.RenewalAddress.Address2 || ""}<br />
            {address.RenewalAddress.City}, {address.RenewalAddress.State}
            {address.RenewalAddress.ZipCode}
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row g-2 justify-content-between my-1">
          <div class="col-auto col-md-4 d-md-grid">
            <a
              href={window.route("address.index")}
              use:inertia
              class="btn btn-secondary">Restart</a
            >
          </div>
          <div class="col-auto col-md-4 d-md-grid">
            <a href={window.route("home")} class="btn btn-primary" use:inertia
              >Return to Main Menu</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4 mt-4 mt-md-0">
    <AddressFaq />
    <AdditionalHelp />
  </div>
</div>
